export default {
    path: '/reset-password/:token',
    name: 'reset-password',
    component: () =>
        import(
            /* webpackChunkName: "reset-password" */ '@/views/auth/ResetPassword.vue'
        ),
    meta: {
        layout: 'simple-layout',
        guest: true,
    },
    props: true,
}
